var _g, _g2, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeechBubbleMobilev2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 612 792",
    enableBackground: "new 0 0 612 792",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gzynoC.tif",
    display: "none"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#290F6B",
    d: "M119.6,335.5c0-32.4,19.5-62.8,55-85.7s82.5-35.5,132.7-35.5s97.3,12.6,132.7,35.5 c35.5,22.9,55,53.3,55,85.7s-19.5,62.8-55,85.7c-35.4,22.9-82.5,35.5-132.7,35.5c-6.1,0-12.2-0.2-18.3-0.6l-1.5-0.1l-93.6,143.7 l20.7-158.9l-1.1-0.4c-28-10.5-51.6-25.5-68-43.5C128.6,378.4,119.6,357.1,119.6,335.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M493,335.5c0,16.2-4.9,31.8-14.6,46.6c-9.3,14.3-22.7,27.1-39.8,38.1c-17,11-36.9,19.6-59,25.7 c-22.9,6.2-47.2,9.4-72.3,9.4c-6,0-12.1-0.2-18.1-0.6l-3-0.2l-1.2,1.8l-88,135.1l19.5-149.6l0.2-1.7l-2.3-0.8 c-27.7-10.3-50.9-25.2-67.2-43c-16.8-18.4-25.6-39.3-25.6-60.8c0-16.2,4.9-31.8,14.6-46.6c9.3-14.3,22.7-27.1,39.8-38.1 c17-11,36.9-19.6,59-25.7c22.9-6.2,47.2-9.4,72.3-9.4s49.3,3.2,72.3,9.4c22.1,6,42,14.7,59,25.7s30.4,23.8,39.8,38.1 C488.1,303.6,493,319.3,493,335.5 M497.1,335.5c0-67.7-85-122.5-189.8-122.5s-189.8,54.8-189.8,122.5c0,45.3,38.2,84.9,94.9,106.1 L190.8,608l98.1-150.6l0,0c6.1,0.4,12.2,0.6,18.5,0.6C412.2,458,497.1,403.2,497.1,335.5L497.1,335.5z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 204.5802 260.1415)",
    fill: "#FFFFFF",
    fontFamily: "Public Sans,sans-serif",
    fontSize: 16
  }, "We have now found a range")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 170.5802 280.1415)",
    fill: "#FFFFFF",
    fontFamily: "Public Sans,sans-serif",
    fontSize: 16
  }, "of careers that require skills similar to")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 170.5802 300.1415)",
    fill: "#FFFFFF",
    fontFamily: "Public Sans,sans-serif",
    fontSize: 16
  }, "your own and so are a great Upskill or")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 230.5802 320.1415)",
    fill: "#FFFFFF",
    fontFamily: "Public Sans,sans-serif",
    fontSize: 16
  }, "Reskill option for you.")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 274.5802 355.1415)",
    fill: "#FFFFFF",
    fontFamily: "Public Sans,sans-serif",
    fontSize: 16
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 186.5802 365.1415)",
    fill: "#FFFFFF",
    fontFamily: "Public Sans,sans-serif",
    fontSize: 16
  }, "Press play for a short explanation ")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 198.5802 385.1415)",
    fill: "#FFFFFF",
    fontFamily: "Public Sans,sans-serif",
    fontSize: 16
  }, "  about the Careers  and Courses")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 238.5802 405.1415)",
    fill: "#FFFFFF",
    fontFamily: "Public Sans,sans-serif",
    fontSize: 16
  }, " explorer from Laicie.")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubbleMobilev2);
export default __webpack_public_path__ + "static/media/speech-bubble-mobilev2.6ecfcc711ddf2bf64325e3a56ca9064b.svg";
export { ForwardRef as ReactComponent };